import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useTranslation, Trans } from 'react-i18next'
import classNames from 'classnames'

import { toggleUserCommunityFeature } from '../../../actions/featureActions'
import { Link } from 'react-router-dom'
import Toggle from '../../common/form/Toggle'
import ClubsPreview from '../../../assets/images/op-36-clubs/clubs-preview.webp'

import classes from './GolfClubs.module.scss'

const GolfClubs = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const currentUser = useSelector(state => state.user.current_user)
  const community = currentUser.communities[0]

  const features = community.features || []
  const golfClubsFeature = features.find(feature => feature.key === 'golf_clubs') || { key: 'golf_clubs', enabled: false, name: 'Golf Clubs' }
  const [enabled, setEnabled] = useState(golfClubsFeature.enabled)

  const [loading, setLoading] = useState(false)

  const handleToggleChange = () => {
    setLoading(true)

    dispatch(toggleUserCommunityFeature(community.id, { key: golfClubsFeature.key, enabled: enabled }))
      .then(() => toast.success(t('communitySettings.golfClubs.settingsUpdatedSuccess')))
      .catch(() => toast.error(t('communitySettings.common.genericError')))
      .finally(() => { setEnabled((prev) => !prev); setLoading(false) })
  }

  return (
    <div className={classes.GolfClubsTab}>
      <div className={classNames('py-4 px-3', classes.form)}>
        <h6 className={classNames('pb-4', classes.title)}>{t('communitySettings.golfClubs.title')}</h6>

        <img className='w-100' src={ClubsPreview} alt={t('communitySettings.golfClubs.previewAlt')}/>

        <div className={classNames('py-3', classes.description)}>
          <section className='mb-3'>
            <span className='font-weight-bold'>{t('communitySettings.golfClubs.fitHeadline')}</span>
            <br/>

            {t('communitySettings.golfClubs.fitDescription')}
          </section>

          <section className='mb-3'>
            <span className='font-weight-bold'>{t('communitySettings.golfClubs.beginnersCanNow')}</span>

            <ul>
              <li>{t('communitySettings.golfClubs.benefitOneClubAtATime')}</li>
              <li>{t('communitySettings.golfClubs.benefitCustomFit')}</li>
              <li>{t('communitySettings.golfClubs.benefitAdultOrJunior')}</li>
              <li>{t('communitySettings.golfClubs.benefitAffordableGear')}</li>
            </ul>
          </section>

          <section className='mb-3'>
            <span className='font-weight-bold'>{t('communitySettings.golfClubs.howItWorks')}</span>
            <br/>

            {t('communitySettings.golfClubs.howItWorksDescription')}
          </section>

          <p className='font-italic bt-2 mb-3'>
            {t('communitySettings.golfClubs.disablePreference')}
          </p>

          <Link
            className='font-weight-bold'
            to='https://intercom.help/op-36/en/articles/12507499-operation-36-clubs-everything-you-need-to-know'
            target='_blank'
            rel='noreferrer'
          >
            {t('communitySettings.golfClubs.learnMore')}
          </Link>
        </div>

        <div className={classNames(classes.toggleWrapper, 'mt-2 d-flex align-items-center')}>
          <Toggle name='enabled' checked={enabled} disabled={loading} onChange={handleToggleChange}/>

          <label className={classNames(classes.checkboxLabel, 'ml-3')} htmlFor='enabled'>
            {enabled
              ? (
                <div>
                  <Trans i18nKey='communitySettings.golfClubs.enabledLabel' components={{ b: <span className='font-weight-bold'/> }} />
                </div>
              )
              : (
                <div>
                  <Trans i18nKey='communitySettings.golfClubs.disabledLabel' components={{ b: <span className='font-weight-bold'/> }} />
                </div>
              )
            }
          </label>
        </div>
      </div>
    </div>
  )
}

export default GolfClubs
